import PropTypes from "prop-types";
import React from "react";
import { RiExternalLinkLine } from 'react-icons/ri'

import { Link } from "react-router-dom";
import { AzureAD, AuthenticationState } from 'react-aad-msal';


import { login, logout, signInAuthProvider} from "./authProvider";
 


var lastHover;

function navLinkHover(e) {
  e.target.parentElement.parentElement.classList.add(e.target.name);
  lastHover = e.target.name;
}

function clearHover(e) {
  lastHover !== undefined &&
    e.target.parentElement.parentElement.classList.remove(lastHover);
}

const Nav = (props) => {
  //console.log('nav', props)
  //const [provider, setProvider] = useState(null);
let provider = signInAuthProvider();

  return (
    <nav id="nav">
      <div
        className="mobile-bg"
        onClick={(event) => {
          event.target.parentNode.classList.remove("open");
        }}
      ></div>
      <div className="nav-inner">
        <button
          className="mobile-click"
          onClick={(event) => {
            event.target.parentNode.parentNode.classList.toggle("open");
          }}
        >
          ☰
        </button>
        <a
          href="https://circadence.com/"
          style={{
            color: `white`,
            textDecoration: `none`,
          }}
        >
          <svg
            className="logo-color-black"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 250.9 48.6"
          >
            <path
              className="nav-logo-text"
              d="M19.7 31.8l-1.6-1.6c-2.1 2-4.1 3.2-7.1 3.2-4.8 0-8.5-4-8.5-9.1s3.6-9 8.5-9c3 0 5 1.3 6.9 3l1.7-1.8C17.4 14.4 15 13 11.1 13 4.6 13 0 18.1 0 24.3c0 6.3 4.7 11.3 11 11.3 3.9 0 6.4-1.5 8.7-3.8m4.5 3.5h2.5V13.4h-2.5v21.9zm27 0l-6.7-8.9c3.4-.6 5.9-2.7 5.9-6.4 0-3.9-3.1-6.5-7.9-6.5h-9.4v21.9h2.5v-8.5h6.3l6.3 8.5h3zM47.9 20c0 2.8-2.3 4.5-5.6 4.5h-6.7v-8.9h6.8c3.5.1 5.5 1.7 5.5 4.4M73 31.8l-1.6-1.6c-2.1 2-4.1 3.2-7.1 3.2-4.8 0-8.5-4-8.5-9.1s3.6-9 8.5-9c3 0 5 1.3 6.9 3l1.7-1.8c-2.2-2.1-4.6-3.5-8.5-3.5-6.4 0-11.1 5.1-11.1 11.3 0 6.3 4.7 11.3 11 11.3 3.9 0 6.4-1.5 8.7-3.8m13.7-18.6h-2.3l-10 22H77l2.6-5.8h11.9l2.6 5.8h2.7l-10.1-22zm3.8 14.1h-10l5-11.2 5 11.2zm28.7-3c0-6.2-4.8-10.9-11.6-10.9H100v21.9h7.6c6.8 0 11.6-4.8 11.6-11m-2.6 0c0 4.9-3.5 8.6-9.1 8.6h-5.1V15.7h5.1c5.6 0 9.1 3.8 9.1 8.6m22.7-10.9h-15.8v21.9h16V33H126v-7.7h11.9V23H126v-7.5h13.3v-2.1zm21 17.5l-13.8-17.5h-2.3v21.9h2.4v-18l14.1 17.9h2V13.4h-2.4v17.5zm26.4.9l-1.6-1.6c-2.1 2-4.1 3.2-7.1 3.2-4.8 0-8.5-4-8.5-9.1s3.6-9 8.5-9c3 0 5 1.3 6.9 3l1.7-1.8c-2.2-2.1-4.6-3.5-8.5-3.5-6.4 0-11.1 5.1-11.1 11.3 0 6.3 4.7 11.3 11 11.3 3.9 0 6.4-1.5 8.7-3.8m20.1-18.4H191v21.9h16V33h-13.5v-7.7h11.9V23h-11.9v-7.5h13.3v-2.1z"
            />
            <path
              className="st0"
              d="M238.6 22.8h10.3l-1.8-4.7-4.3-.3L244 10l-2.3-6.1z"
            />
            <path
              className="st1"
              d="M238.3 2.6L234.5.8l2.6 12.1zM234 48.6l4.2-1.8-1.1-10.5z"
            />
            <path
              className="st0"
              d="M229.9 0l-3.8 6.1 3.7 11.2-9.7-1.1-4 6.6h20.5z"
            />
            <path
              className="st2"
              d="M238.8 25.9H249l-1.8 4.7-4.3.4 1.2 7.7-2.3 6.1zM230 48.6l-3.5-5.8 3.4-11.5-10.6-.1-3.1-5.4h20.5z"
            />
            <path
              className="st0"
              d="M249 10.4c.2 0 .3-.1.3-.4 0-.2-.1-.3-.3-.3h-.3v.7h.3zm-.7-1h.8c.4 0 .7.2.7.6 0 .3-.2.5-.4.5l.1.1.4.8h-.4l-.4-.8h-.3v.8h-.4v-2zm.7 2.6c.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6-.9 0-1.5.7-1.5 1.6-.1.9.6 1.6 1.5 1.6m0-3.6c1.1 0 2 .9 2 2s-.9 2-2 2-1.9-.9-1.9-2c-.1-1.1.8-2 1.9-2"
            />
          </svg>

          <svg
            className="logo-color-black mobile"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 250.9 48.6"
            viewBox="0 0 34.9 48.6"
          >
            <g>
              <g>
                <polygon
                  className="st0"
                  points="22.6,22.8 32.8,22.8 31,18.1 26.7,17.8 27.9,10 25.6,3.9 		"
                />
                <polygon className="st1" points="22.3,2.6 18.4,0.8 21,12.9 		" />
                <polygon className="st1" points="18,48.6 22.1,46.8 21,36.3 		" />
                <polygon
                  className="st0"
                  points="13.9,0 10.1,6.1 13.7,17.3 4,16.2 0,22.8 20.5,22.8 		"
                />
                <polygon
                  className="st2"
                  points="22.7,25.9 32.9,25.9 31.1,30.6 26.9,31 28.1,38.7 25.8,44.8 		"
                />
                <polygon
                  className="st2"
                  points="14,48.6 10.4,42.8 13.8,31.3 3.2,31.2 0.1,25.8 20.6,25.8 		"
                />
              </g>
              <path
                className="st0"
                d="M33,10.4c0.2,0,0.3-0.1,0.3-0.4c0-0.2-0.1-0.3-0.3-0.3h-0.3v0.7H33z M32.2,9.4H33c0.4,0,0.7,0.2,0.7,0.6
		c0,0.3-0.2,0.5-0.4,0.5v0c0,0,0,0,0.1,0.1l0.4,0.8h-0.4L33,10.6h-0.3v0.8h-0.4V9.4z M32.9,12c0.9,0,1.6-0.7,1.6-1.6
		c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.5,0.7-1.5,1.6C31.4,11.3,32,12,32.9,12 M32.9,8.4c1.1,0,2,0.9,2,2c0,1.1-0.9,2-2,2
		c-1.1,0-1.9-0.9-1.9-2C31,9.3,31.8,8.4,32.9,8.4"
              />
            </g>
          </svg>
        </a>
        <ul className="main-nav">
          <span className="links-container">
            <li>
              <a href="https://projectares.academy" target="_blank">Project Ares <RiExternalLinkLine style={{ marginLeft: 4 }} /></a>
              {/* <div className="nav-dropdown   ">
                <ul className="sub-nav">
                  <span className="links-container">
                    <li>
                      <a href="https://circadence.com/teach/cyber-security-academic">
                        Teach Cyber
                      </a>
                    </li>

                    <li>
                      <a href="https://circadence.com/protect/cyber-training-enterprise-readiness">
                        Train in Cyber
                      </a>
                    </li>
                    <li>
                      <a href="https://circadence.com/protect/cyber-training-government/">
                        Government Cyber Training
                      </a>
                    </li>

                    <li>
                      <a href="https://circadence.com/demo">Try Project Ares</a>
                    </li>
                    <li>
                      <a href="https://projectares.academy" target="_blank">
                        Solution Details <RiExternalLinkLine style={{ marginLeft: 4 }} />
                      </a>
                    </li>

                    <li>
                      <Link to="/faq">Frequently Asked Questions</Link>
                    </li>
                  </span>
                </ul>
              </div> */}
            </li>
            <li>
              <a href="https://projectares.academy/learning-catalog">Resource Center</a>
              <div className="nav-dropdown   ">
                <ul className="sub-nav">
                  <span className="links-container">
                    <li>
                      <a href="https://projectares.academy/learning-catalog" target="_blank">Cyber Curriculum Guide <RiExternalLinkLine style={{ marginLeft: 4 }} /></a>
                    </li>
                    <li>
                      <a href="https://projectares.academy/support" target="_blank">Support <RiExternalLinkLine style={{ marginLeft: 4 }} /></a>
                    </li>

                    <li>
                      <a href="https://news.projectares.academy/information-hub/">
                        Information Hub
                      </a>
                    </li>

                    <li>
                      <a href="https://news.projectares.academy/blog">Blog</a>
                    </li>
                    <li>
                      <a href="https://news.projectares.academy/news">News</a>
                    </li>
                    <li>
                      <a href="https://projectares.academy/faq" target="_blank">Frequently Asked Questions <RiExternalLinkLine style={{ marginLeft: 4 }} /></a>
                    </li>
                    <li>
                      <a href="https://news.projectares.academy/product-updates/">Product Updates</a>
                    </li>

                    <li>
                      <a href="https://projectares.academy/subscribe-to-newsletter" target="_blank">
                        Newsletter Sign Up <RiExternalLinkLine style={{ marginLeft: 4 }} />
                      </a>
                    </li>
                  </span>
                </ul>
              </div>
            </li>

            {/*<li>
              <a href="https://help-center-circadence.web.app/">Resource Center</a>
              <div className="nav-dropdown   ">
           
                <ul className="sub-nav">
                  <span className="links-container">
          
                  <li>
                      <a href="https://help-center-circadence.web.app/getting-started">Getting Started</a>
                    </li>
                    <li>
                      <a href="https://help-center-circadence.web.app/scenario-catalog">Cyber Scenario Library</a>
                    </li>
                    <li>
                      <a href="https://live-circadence.pantheonsite.io/product-updates/">Product Updates</a>
                    </li>
                    <li>
                      <a href="https://live-circadence.pantheonsite.io/news">News</a>
                    </li>
                    <li>
                      <a href="https://help-center-circadence.web.app/scenario-catalog">Training Development</a>
                    </li>
                    <li>
                      <a href="https://live-circadence.pantheonsite.io/blog">Blog</a>
                    </li>
                    <li>
                    <Link href=" /contact/support">Support</Link>
                    </li>
                    <li>
                      <a href="https://live-circadence.pantheonsite.io/content-library/">Information Hub</a>
                    </li>
                   
                    <li>
                      <Link href="/newsletter">Newsletter Sign Up</Link>
                    </li>

                  </span>
                </ul>
              </div>
</li>*/}

            <li>
              <a href="#">Company</a>
              <div className="nav-dropdown   ">
                <ul className="sub-nav">
                  <span className="links-container">
                    <li>
                      <a href="https://circadence.com/jobs">Careers</a>
                    </li>
                    <li>
                      <a href="https://projectares.academy/schedule-a-demo-consultation" target="_blank">
                        Contact Us <RiExternalLinkLine style={{ marginLeft: 4 }} />
                      </a>
                    </li>
                  </span>
                </ul>
              </div>
            </li>

            <li>
              <a href="#">Partners</a>
              <div className="nav-dropdown   ">
                <ul className="sub-nav">
                  <span className="links-container">
                    <li>
                      <a href="https://marketing.circadence.com/acton/fs/blocks/showLandingPage/a/36273/p/p-00f8/t/page/fm/0">
                        Partner With Us
                      </a>
                    </li>
                    <li>
                      <a href="https://partners.circadence.com/s/login/?ec=302&startURL=%2Fs%2F">
                        Partner Portal
                      </a>
                    </li>
                  </span>
                </ul>
              </div>
            </li>
          </span>
        </ul>
        <ul className="main-nav login">
          <span className="links-container">
            <li style={{ justifyContent: 'flex-end', paddingRight: 20, textAlign: 'right' }}>
              {/* <Test/>*/}
              <a
                href="https://app.projectares.academy"
                style={{ display: "flex" }}
                id='launchAres'
                target='_blank'
                style={{ marginLeft: 'auto' }}
              >
                {" "}
                <span>Login <RiExternalLinkLine style={{ verticalAlign: 'middle', position: 'relative', top: -2, marginLeft: 4 }} /></span>
              </a>


             
              {/* <div className="nav-dropdown   ">
           
                <ul className="sub-nav">
                  <span className="links-container">
{                 <li>
                      <a href="https://circadence.com/cyberbridge">CyberBridge</a>
</li>}

                    <li>
                      <a href="https://circadence.com/cancel-subscription">Cancel Subscription</a>
                    </li>
                  { /* <li>
                      <a href="https://circadence.com/ares-accomplishments-verification">My CEU/CPE credits</a>
                    </li>*/
              /*}
                    <li>
                      <a target="_blank" href="https://partners.circadence.com/s/login/?ec=302&startURL=%2Fs%2F">Partner Portal</a>
                    </li>

                  </span>
                </ul>
                  </div>*/}
            </li>
          </span>
        </ul>
      </div>
    </nav>
  );
};

Nav.propTypes = {
  siteTitle: PropTypes.string,
  customID: PropTypes.string,
};

Nav.defaultProps = {
  siteTitle: ``,
};

export default Nav;
